import envy from "./assets/logos/envy.svg";
import excitement from "./assets/logos/excitement.svg";
import joy from "./assets/logos/joy.svg";
import peace from "./assets/logos/peace.svg";
import pride from "./assets/logos/pride.svg";
import sadness from "./assets/logos/sadness.svg";

export const COLOR_NAMES = [
  "pride",
  "excitement",
  "joy",
  "sadness",
  "envy",
  "peace",
] as const;

export const BRAND_IMAGES_BY_NAME = {
  pride,
  excitement,
  joy,
  sadness,
  envy,
  peace,
};

export const BRAND_IMAGES = COLOR_NAMES.map(
  (color) => BRAND_IMAGES_BY_NAME[color]
);
